import React from 'react';

import './SavedProductList.scss';

import BackButton from '../BackButton/BackButton.jsx';
import DiscountProgramProductList from '../DiscountProgramProductList/DiscountProgramProductList.jsx';

export default function SavedProductList(props) {
  return (
    <section id="savedProductList">
      <BackButton />

      <DiscountProgramProductList
        {...props}
        list={props.user.wishlistEntries || []}
      />

      <button className="savedProductList-button" onClick={() => removeItems()}>
        Alle producten verwijderen
      </button>
    </section>
  );

  function removeItems() {
    (props.user.wishlistEntries || []).forEach((entry) =>
      props.removeWishlist({ variables: { recordKey: entry.campaign.xuid } })
    );
  }
}
